(function () {
  'use strict';
  var configEl = document.getElementById('juicy-flavour-config');
  if (!configEl) return;
  var config;
  try { config = JSON.parse(configEl.textContent); } catch (e) { return; }
  var cart = null;
  var keys = new Set();
  var drinks = 0;
  var refreshTimer;
  function key(value) { return String(value || '').toUpperCase().replace(/[\s-]+/g, ''); }
  function hasCap(proposedQty) {
    return drinks + proposedQty < Number(config.threshold || 50);
  }
  function blocked(value, proposedQty, localKeys) {
    var k = key(value);
    var pool = new Set(keys);
    (localKeys || []).forEach(function (v) { pool.add(key(v)); });
    return hasCap(proposedQty) && pool.size >= Number(config.max || 5) && !pool.has(k);
  }
  function productQuantity() {
    var input = document.querySelector('form[action*="/cart/add"] input[name="quantity"]');
    return Math.max(1, Number(input && input.value) || 1);
  }
  function notice() {
    var el = document.getElementById('juicy-flavour-notice');
    // The party-pack chooser has its own guidance beside the flavour grid.
    // A second fixed notice covers the heading on narrow screens.
    if (document.querySelector('.bundle-picker')) {
      if (el) el.hidden = true;
      return;
    }
    if (!el) {
      el = document.createElement('div');
      el.id = 'juicy-flavour-notice';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    var capped = hasCap(0) && keys.size >= Number(config.max || 5);
    el.textContent = keys.size + ' / ' + config.max + ' flavours · ' +
      (capped ? 'limit reached. You can add more of your chosen flavours, or order 50+ drinks for more variety.' : 'choose your favourites');
    el.hidden = !capped;
  }
  function cardState() {
    document.querySelectorAll('product-card[data-juice-flavour]').forEach(function (card) {
      var disallowed = blocked(card.dataset.juiceFlavour, 1);
      card.classList.toggle('juicy-flavour-disabled', disallowed);
      card.querySelectorAll('button').forEach(function (button) {
        if (disallowed) {
          if (!button.dataset.juicyPreviousDisabled) button.dataset.juicyPreviousDisabled = button.disabled ? 'yes' : 'no';
          button.disabled = true;
        } else if (button.dataset.juicyPreviousDisabled) {
          if (button.dataset.juicyPreviousDisabled === 'no') button.disabled = false;
          delete button.dataset.juicyPreviousDisabled;
        }
      });
      var link = card.querySelector('.product-card__link');
      if (link) {
        if (disallowed) link.setAttribute('aria-disabled', 'true');
        else link.removeAttribute('aria-disabled');
      }
    });
    document.querySelectorAll('product-card[data-juice-bundle]').forEach(function (card) {
      // The pack chooser remains available: its individual flavour cards
      // enforce the shared pool while chosen flavours can always be repeated.
      card.classList.remove('juicy-flavour-disabled');
    });
    if (config.product_flavour) {
      var disallowed = blocked(config.product_flavour, productQuantity());
      document.querySelectorAll('product-form button[type="submit"], form[action*="/cart/add"] button[type="submit"]').forEach(function (button) {
        if (disallowed) {
          button.dataset.juicyFlavourDisabled = 'true';
          button.disabled = true;
          button.title = 'Five flavours selected. Add more of those flavours, or order 50+ drinks.';
        } else if (button.dataset.juicyFlavourDisabled) {
          button.disabled = false;
          button.removeAttribute('title');
          delete button.dataset.juicyFlavourDisabled;
        }
      });
    }
    notice();
    document.dispatchEvent(new CustomEvent('juicy:flavour-state'));
  }
  function refresh() {
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (next) {
      cart = next;
      keys = new Set();
      drinks = 0;
      (cart.items || []).forEach(function (item) {
        var props = item.properties || {};
        if (props._delivery_fee === 'true' || props['Bundle Size']) return;
        if (props._bundle === 'true' && String(item.product_id) === String(config.bundle_flavour_id)) {
          drinks += item.quantity;
          keys.add(key((item.variant_title || '').split('|')[0]));
        } else if (item.product_type !== 'Delivery Fee' && props._bundle !== 'true') {
          // Non-juice items are ignored by matching their product ID to
          // the all-juices IDs rendered in the current page's catalogue.
          if (retailIds.has(String(item.product_id))) {
            drinks += item.quantity;
            keys.add(key(item.product_title));
          }
        }
      });
      keys.delete('');
      cardState();
    }).catch(function () {});
  }
  var retailIds = new Set((config.retail_ids || []).map(String));
  window.JuicyFlavourUI = {
    blocked: blocked,
    refresh: refresh,
    state: function () { return { keys: Array.from(keys), drinks: drinks, max: Number(config.max || 5) }; }
  };
  document.addEventListener('click', function (event) {
    var card = event.target.closest && event.target.closest('product-card.juicy-flavour-disabled');
    if (card && card.contains(event.target)) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);
  document.addEventListener('submit', function (event) {
    if (config.product_flavour && blocked(config.product_flavour, productQuantity()) &&
        event.target.matches('form[action*="/cart/add"]')) {
      event.preventDefault();
      event.stopPropagation();
      notice();
    }
  }, true);
  ['cart:updated', 'cart:update', 'cart:refresh'].forEach(function (name) {
    document.addEventListener(name, function () {
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(refresh, 150);
    });
  });
  document.addEventListener('change', function (event) {
    if (event.target && event.target.name === 'quantity') cardState();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
})();
